import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import { useTheme } from '../../context/ThemeContext';
import { resultService } from '../../services/api';

const StudentResults: React.FC = () => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  const [results, setResults] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchResults();
  }, []);

  const fetchResults = async () => {
    try {
      setLoading(true);
      const response = await resultService.getAll();
      setResults(response.data || []);
    } catch (error) {
      console.error('Failed to fetch results:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="My Results">
      <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow p-6`}>
        <div className="mb-6 flex justify-between items-center">
          <h2 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            My Results
          </h2>
          <button
            onClick={() => navigate('/')}
            className="text-blue-600 hover:text-blue-700"
          >
            ← Back to Dashboard
          </button>
        </div>

        {loading ? (
          <div className="text-center py-8">Loading...</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className={isDarkMode ? 'bg-gray-700' : 'bg-gray-50'}>
                  <th className="px-4 py-3 text-left">Subject</th>
                  <th className="px-4 py-3 text-left">Exam Type</th>
                  <th className="px-4 py-3 text-center">Marks</th>
                  <th className="px-4 py-3 text-center">Grade</th>
                  <th className="px-4 py-3 text-left">Remarks</th>
                </tr>
              </thead>
              <tbody>
                {results.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center py-8 text-gray-500">
                      No results found
                    </td>
                  </tr>
                ) : (
                  results.map((result) => (
                    <tr key={result.id} className={isDarkMode ? 'border-gray-700' : 'border-gray-200 border-t'}>
                      <td className="px-4 py-3">Subject</td>
                      <td className="px-4 py-3">{result.examType}</td>
                      <td className="px-4 py-3 text-center">
                        {result.marksObtained}/{result.totalMarks}
                      </td>
                      <td className="px-4 py-3 text-center">
                        <span className="px-2 py-1 rounded bg-blue-100 text-blue-800">
                          {result.grade}
                        </span>
                      </td>
                      <td className="px-4 py-3">{result.remarks || '-'}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default StudentResults;
